import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../../../context/provider/UserProvider';
import { Fetch } from '../../../services/api';
import logoAbeja from '../../../assets/images/icon_beexqr.fw.png'
import { notify } from '../../../utils/utils';
import { SocketContext } from '../../../context/provider/SocketProvider';

const urlBase = process.env.REACT_APP_BEEDRONE_WEB_API;

export const PantallaCarga = (req, res) => {
  const [ aToken , setAToken ] = useState(null)
  const { mqttConnect , mqttDisconnect } = useContext(SocketContext);
  const [ cerroSesion, setCerroSesion ] = useState(0)

  const { signIn, signOut } = useContext(UserContext);
  const history = useHistory();


  const intercambioToken = async (req, res) => {
    console.log("1----------intercambioToken respuesta de logeo", req)
    console.log("1----------intercambioToken", res) 

    try {
      const urlParams = new URLSearchParams(req.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const sessionState = urlParams.get('session_state');
      if(state == 'logout_success'){
        if(urlParams.get('error_description')){
          if(urlParams.get('error') == 'access_denied')
          setCerroSesion(1)
        }else{
          setCerroSesion(2)
          return
        }
      }
     
       const jsonData = {
        code: code,
        state: state,
        session_state: sessionState,
      };
      const pkceGuardado = JSON.parse(localStorage.getItem("pkce") || "{}")
      const scopes = JSON.parse(localStorage.getItem("scopes") || "{}")
			localStorage.removeItem("pkce")
      console.log('pkceGuardado',pkceGuardado)

			const bodyParameters = new URLSearchParams({
				grant_type: "authorization_code",
				client_id: process.env.REACT_APP_WSO2IS_CLIENT_ID,
				code: jsonData.code,
				redirect_uri: process.env.REACT_APP_REDIRECT_URI,
				code_verifier: pkceGuardado.codeVerifier,
				scope:  scopes + ' ' + process.env.REACT_APP_SCOPES_TOKEN
			})

			const response = await Fetch({
				url: process.env.REACT_APP_WSO2IS_AUTHORIZATION +'/token',
				method: "POST",
				mode: 'no-cors', 
				body: bodyParameters,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			});

      setAToken(response)
    } catch (error) {
      console.error('Error en intercambioToken:', error);
    }
  };


  useEffect(()=>{
    intercambioToken(req, res)
  },[])


  const obtenerDatosSesion = async () => {
    console.log("ObtenerDatosSesion -> ", aToken)
    try {
        if (aToken.access_token) {
        const response = await fetch(urlBase+'/User/getDataSession', {
          method: 'GET',
          headers: {
            Authorization: 'Bearer ' + aToken.access_token,
            'Content-Type': 'application/json',
          },
        }).then((res) => res.json());

        if (response.isValid) {
          localStorage.setItem('uid',response.content.uid)
          if (aToken.id_token) {
            response.content.id_token = aToken.id_token;
          }
          
          signIn({ ...response.content });
          mqttConnect()

          history.push('/principal');
        }
      }
    } catch (error) {
      console.error('Error en obtenerDatosSesion:', error);
    }
  };

  useEffect(()=>{
    if(cerroSesion == 2){
      notify("Su sesión se cerró correctamente","success")
      history.push("/login")
      mqttDisconnect();
      signOut()
    }else if (cerroSesion == 1){
      notify("Canceló el cerrado de sesión","error")
      window.location.reload(true);
    }

  },[cerroSesion])



  useEffect(()=>{
    aToken && obtenerDatosSesion()
  },[aToken])

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-black flex justify-center items-center z-50">
        <div className="text-white text-center">
        <div className='flex flex-col items-center px-5 mb-10 '>
              <img className='animate-flap-wings container w-auto' src={logoAbeja} alt=''/>
              <p className="text-2xl">Cargando... </p>
        </div>

        </div>
    </div>
    </>
  );
};
